import { Params } from 'react-router-dom';
import { create } from 'zustand';

type State = {
  params: Params;
  currentRouteName: string;
  modifiedReportWarningOpen: boolean;
};

type Action = {
  setParams: (params: State['params']) => void;
  setCurrentRouteName: (currentRouteName: State['currentRouteName']) => void;
  setModifiedReportWarningOpen: (modifiedReportWarningOpen: State['modifiedReportWarningOpen']) => void;
};

export const useRouterStore = create<State & Action>((set) => ({
  params: {},
  currentRouteName: '',
  modifiedReportWarningOpen: true,
  setParams: (params) => {
    set(() => ({ params }));
  },
  setCurrentRouteName: (currentRouteName) => {
    set(() => ({ currentRouteName }));
  },
  setModifiedReportWarningOpen: (modifiedReportWarningOpen) => {
    set(() => {
      return { modifiedReportWarningOpen };
    });
  }
}));
